export const ONBOARDING_CONTAINER_HEIGHT = 400;
export const ONBOARDING_CHART_WIDTH = 644;
export const ONBOARDING_CHART_WIDTH_MOBILE = 360;
export const ONBOARDING_CHART_HEIGHT = 240;
export const CHART_PADDING_TOP = 20;
export const ONBOARDING_CHART_PADDING_LEFT = 20;

export const findAxisYPosition = (value: number): number => {
  return (
    ONBOARDING_CONTAINER_HEIGHT - (value / 100) * (ONBOARDING_CONTAINER_HEIGHT - CHART_PADDING_TOP)
  );
};

export const findAxisXPosition = (
  time: string,
  chartStartTime: string,
  chartEndTime: string
): number => {
  const startTime = new Date(chartStartTime).getTime();
  const endTime = new Date(chartEndTime).getTime();
  const currentTime = new Date(time).getTime();
  const totalDuration = endTime - startTime;
  const currentDuration = currentTime - startTime;
  return (currentDuration / totalDuration) * ONBOARDING_CHART_WIDTH;
};
